import { useContext } from 'react'

import { MrpDistributionContext } from '@provider/Mrp/DistributionProvider'

import type { IMrpDistributionContext } from '@base/@types/providers/Mrp/DistributionProvider'

export default function useMrpDistribution(): IMrpDistributionContext {
  const context = useContext(MrpDistributionContext)

  return context
}
